module.exports = __webpack_public_path__ + "img/tips3list1img5.25cd893d.jpg";